import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import reduxThunk from 'redux-thunk';

import reducers from './reducers';
import WithAuth from './middleware/WithAuth'
import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';

import Dashboard from './pages/Dashboard'
import Login from './pages/Login'
import NavBar from './components/NavBar'
import Contacts from './pages/Contacts';
import Templates from './pages/Templates';
import Chat from './components/Chat';

import { WS_URL } from './constants';
// This is where we combine the react redux base our application
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  reducers,
  composeEnhancers(applyMiddleware(reduxThunk))
);

const incomingSocket = new WebSocket(`${WS_URL}pull/incoming/`)
const conversationSocket = new WebSocket(`${WS_URL}pull/conversation/`)

incomingSocket.onerror = () => {
  alert('Web socket had an error, try reloading the page')
}

incomingSocket.onclose = () => {
  console.log('Web socket closed')
}

ReactDOM.render(
  <ThemeConfig>
  <GlobalStyles />
    <Provider store={store}>
      <BrowserRouter>
          <React.StrictMode>
            <Routes>
              <Route path="/login" exact element={<Login/>} />
              <Route path="/" exact element={
                <div style={{width: '100vw', height: '100vh' }}>
                {/* Renders top to bottom */}
                <WithAuth>
                  <NavBar/>
                  <Dashboard socket={incomingSocket}/>
                  <Chat socket={conversationSocket}/>
                </WithAuth>
                </div>
              }/>
              <Route path="/contacts" exact element={
                <div style={{width: '100vw', height: '100vh' }}>
                {/* Renders top to bottom */}
                <WithAuth>
                  <NavBar/>
                  <Contacts/>
                  <Chat socket={conversationSocket}/>
                </WithAuth>
                </div>
              }/>
              <Route path="/templates" exact element={
                <div style={{width: '100vw', height: '100vh' }}>
                {/* Renders top to bottom */}
                <WithAuth>
                  <NavBar/>
                  <Templates/>
                  <Chat socket={conversationSocket}/>
                </WithAuth>
                </div>
              }/>
            </Routes>
          </React.StrictMode>
        </BrowserRouter>
    </Provider>
  </ThemeConfig>,
  document.getElementById('root')
);